import {InnerBlocks, RichText} from "@wordpress/block-editor";
wp.blocks.registerBlockType('meetravel/section-header', {
    title: "Section Header Container",
    category : 'layout',
    icon : 'layout',
    attributes: {
    },

    edit(props){
        return (
                <header className={'section-header'}>
                    <InnerBlocks allowedBlocks={["meetravel/section-title", "meetravel/section-description"]}/>
                </header>
        )
    },

    save(props) {
        return (
                <header className={"section-header"}>
                    <InnerBlocks.Content/>
                </header>
        )
    },


})